<template>
  <div class="view-workout text-light pb-5">
    <header class="mb-4">
      <div class="container">
        <div class="row justify-content-center text-center mb-2">
          <div class="col-lg-4 col-8 text-lg-right">
            <img src="@/assets/images/workout/logo.png" class="img-fluid" />
          </div>
          <div class="col-lg-3 col-11 text-lg-left">
            <h2 class="font-condensed">
              Prepare-se para a maior transformação física da sua vida!
            </h2>
          </div>
        </div>
        <div class="text-center">
          <router-link
            :to="{ name: 'workout-history' }"
            class="btn btn-secondary rounded-pill btn-strong"
            >Ver Histórico</router-link
          >
        </div>
      </div>
    </header>

    <action-dispatcher
      v-if="$user.user.perfil"
      action="workout/getFiveExercises"
      :parameters="{ level, gender }"
      class="py-4"
    >
      <div class="px-4 px-lg-5">
        <h5>Musculação <small class="text-secondary">(5 dias)</small></h5>
      </div>
      <div class="position-relative">
        <div class="px-4 px-lg-5">
          <swiper :navigation="true" :breakpoints="breakpoints">
            <swiper-slide v-for="exercise in fiveExercises" :key="exercise.id">
              <router-link
                class="link-workout-exercise"
                :to="{ name: 'workout-exercise', params: { id: exercise.id } }"
                :style="`background-image: url(${exercise.image})`"
              >
                <div class="title">
                  <h3 class="text-warning font-condensed mb-1">
                    {{ exercise.title }}
                  </h3>
                  {{ exercise.subtitle }}
                </div>
              </router-link>
            </swiper-slide>
          </swiper>
        </div>
      </div>
    </action-dispatcher>

    <action-dispatcher
      v-if="$user.user.perfil"
      action="workout/getThreeExercises"
      :parameters="{ level, gender }"
      class="py-4"
    >
      <div class="px-4 px-lg-5">
        <h5>Musculação <small class="text-secondary">(3 dias)</small></h5>
      </div>
      <div class="position-relative">
        <div class="px-4 px-lg-5">
          <swiper :navigation="true" :breakpoints="breakpoints">
            <swiper-slide v-for="exercise in threeExercises" :key="exercise.id">
              <router-link
                class="link-workout-exercise"
                :to="{ name: 'workout-exercise', params: { id: exercise.id } }"
                :style="`background-image: url(${exercise.image})`"
              >
                <div class="title">
                  <h3 class="text-warning font-condensed mb-1">
                    {{ exercise.title }}
                  </h3>
                  {{ exercise.subtitle }}
                </div>
              </router-link>
            </swiper-slide>
          </swiper>
        </div>
      </div>
    </action-dispatcher>

    <action-dispatcher
      v-if="$user.user.perfil"
      action="workout/getRecordedExercises"
      class="py-4"
    >
      <div v-if="recordedExists" class="px-4 px-lg-5">
        <h5>Treinos Gravados</h5>
      </div>
      <div v-if="recordedExists" class="position-relative">
        <div class="px-4 px-lg-5">
          <swiper :navigation="true" :breakpoints="breakpoints">
            <swiper-slide v-for="exercise in recorded" :key="exercise.id">
              <router-link
                class="link-workout-exercise"
                :to="{ name: 'workout-recorded', params: { id: exercise.id } }"
                :style="`background-image: url(${exercise.image})`"
              >
                <div class="title">
                  <h3 class="text-warning font-condensed mb-1">
                    {{ exercise.title }}
                  </h3>
                  {{ exercise.subtitle }}
                </div>
              </router-link>
            </swiper-slide>
          </swiper>
        </div>
      </div>
    </action-dispatcher>

    <action-dispatcher action="workout/getMeet">
      <div v-if="meet" class="px-4 px-lg-5 py-4">
        <h5 class="mb-4">Academia on-line</h5>

        <div class="row justify-content-center align-items-center">
          <div class="col-lg-6 text-right">
            <img :src="meet.image" class="w-100" />
          </div>
          <div class="col-lg-5 py-4">
            <h4 class="mb-3">Treinar ao vivo e de onde quiser</h4>
            <p class="text-secondary mb-4">
              <i class="fas fa-calendar mr-1"></i> {{ meet.sub_title }}
            </p>
            <router-link
              :to="{ name: 'workout-meet' }"
              class="btn btn-warning btn-strong rounded-pill px-5 mx-2"
            >
              ENTRAR NA AULA
            </router-link>
          </div>
        </div>
      </div>
    </action-dispatcher>

    <div class="py-4">
      <div class="px-4 px-lg-5">
        <h5>Cadernos de ativação</h5>
      </div>
      <action-dispatcher
        class="position-relative"
        action="courses/getCategoryLessons"
        :parameters="41"
      >
        <div class="px-4 px-lg-5">
          <swiper :navigation="true" :breakpoints="breakpoints">
            <template v-for="lesson in categoryLessons[41]">
              <swiper-slide v-if="!lesson.is_month" :key="lesson.id">
                <lesson-slide :lesson="lesson" />
              </swiper-slide>
            </template>
          </swiper>
        </div>
      </action-dispatcher>
    </div>

    <b-modal
      v-model="profileDialog"
      hide-footer
      hide-header
      content-class="bg-workout"
      no-close-on-backdrop
    >
      <profile-dialog @close="profileDialog = false" />
    </b-modal>
  </div>
</template>

<script>
import { get } from "lodash";
import { mapState } from "vuex";
import { breakpoints } from "@/functions/helpers.js";
import Swiper from "@/components/Swiper";
import SwiperSlide from "@/components/SwiperSlide";
import ProfileDialog from "@/components/workout/ProfileDialog";
import LessonSlide from "@/components/home/LessonSlide";

export default {
  components: {
    Swiper,
    SwiperSlide,
    ProfileDialog,
    LessonSlide
  },
  data() {
    return {
      breakpoints,
      profileDialog: !this.$user.user.perfil
    };
  },
  computed: {
    ...mapState("workout", [
      "fiveExercises",
      "threeExercises",
      "meet",
      "recorded"
    ]),
    ...mapState("courses", ["categoryLessons"]),
    recordedExists() {
      return this.recorded && this.recorded.length;
    },
    level() {
      return get(this.$user.user, "perfil.number_workouts_week", 0);
    },
    gender() {
      return get(this.$user.user, "perfil.gender", "m");
    }
  }
};
</script>

<style lang="scss" scoped>
.view-workout {
  header {
    background-image: url(../assets/images/workout/bg-header.jpg);
    background-size: cover;
    background-position-x: center;
    padding: 140px 0 35px;

    .btn {
      padding: 12px 24px;
      min-height: 0;
    }
  }

  .link-workout-exercise {
    width: 100%;
    position: relative;
    height: 0;
    padding-bottom: 155%;
    display: block;
    background-size: cover;
    background-position: center center;
    transition: 0.2s opacity;

    &.recorded {
      padding-bottom: 60%;
    }

    .title {
      font-size: 15px;
      color: #eee;
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      padding: 150px 12px 12px;
      background: linear-gradient(
        180deg,
        rgba(23, 23, 23, 0) 0%,
        rgba(23, 23, 23, 0.85) 72.76%
      );
      margin-bottom: 0;
    }

    &:hover {
      opacity: 0.8;
    }
  }
}
</style>
